import isVerifyTokenGuard from "@/guards/verifyTokenGuard";

export default {
    name: 'catalog-federal-entities',
    component: () => import(/* webpackChunkName: "base-layout" */ '@/layouts/BaseLayout.vue'),
    children: [
        {
            path: '',
            name: 'catalog-federal-entities-index',
            beforeEnter: [isVerifyTokenGuard],
            meta: {
                breadcrumbs: [
                                        {
                        transKey: 'breadcrumbs.official-catalogs',
                        isActive: false
                    },
                    {
                        transKey: 'breadcrumbs.catalog-federal-entities-index',
                        isActive: true
                    }
                ]
            },
            component: () => import(/* webpackChunkName: "catalog-federal-entities-index" */ '@/modules/configurations/catalogs/catalog-federal-entities/views/Index.vue')
        }
    ]
}
